import { StarRatingPropsTypes } from "../StarRatingPropsTypes";
import images from "../../../ImageVariables";
import "../SCSS/stylesMobile.css";
import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";

function StarRatingMobileView({
  handleChangeInputStarRating,
  surveyAnswers,
  isPreview,
  questionObjVariable,
  questionId,
  surveyAnswersInfo,
}: StarRatingPropsTypes) {
  return (
    <div className="mobile-view-supplier-view-star-rating-cover">
      {questionObjVariable?.[questionId]?.optionInfo?.optionOrder?.map(
        (optionId, index) => {
          return (
            <div
              key={optionId}
              className="supplier-view-star-rating-stars"
              onClick={() =>
                !isPreview &&
                surveyAnswersInfo?.surveyStatus !==
                  EnumSurveyAnswerStatus?.COMPLETED &&
                handleChangeInputStarRating!(
                  questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[
                    optionId
                  ]?.ratingCount!,
                  questionId,
                  optionId,
                  questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[
                    optionId
                  ]?.optionName,
                  Number(
                    questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[
                      optionId
                    ]!.weightage!
                  )
                )
              }
            >
              {surveyAnswers?.[questionId]?.rating &&
              index + 1 <= surveyAnswers?.[questionId]?.rating! ? (
                <div className="supplier-view-star-rating-image-text-cover">
                  <div className="supplier-view-star-rating-image-cover">
                    <img
                      src={images.StarRatingYellow}
                      alt="supplier-view-star-golden"
                      height={"25px"}
                    />
                  </div>
                  <div className="supplier-view-star-rating-text-cover">
                    {
                      questionObjVariable?.[questionId]?.optionInfo
                        ?.optionObj?.[optionId]?.ratingCount
                    }
                  </div>
                </div>
              ) : (
                <div className="supplier-view-star-rating-image-text-cover">
                  <div className="supplier-view-star-rating-image-cover">
                    <img
                      src={images.StarRatingGray}
                      alt="supplier-view-star-gray"
                      height={"25px"}
                    />
                  </div>
                  <div className="supplier-view-star-rating-text-cover">
                    {
                      questionObjVariable?.[questionId]?.optionInfo
                        ?.optionObj?.[optionId]?.ratingCount
                    }
                  </div>
                </div>
              )}
            </div>
          );
        }
      )}
    </div>
  );
}

export default StarRatingMobileView;
